export default "__VITE_ASSET__DpYsZKLh__"